import {
    SET_ALL_PRODUCTS,
    SET_ALL_PRODUCTS_ERROR,
    SET_ALL_PRODUCTS_SUCCESS,
} from "core-web/state/models/Products/constants";

import store from "core-web/state/store";

export const setAllProducts = (products) => (dispatch) => {
    dispatch({ type: SET_ALL_PRODUCTS });

    try {
        dispatch({ type: SET_ALL_PRODUCTS_SUCCESS, products });
    } catch (e) {
        dispatch({ type: SET_ALL_PRODUCTS_ERROR });
    }
};

export default (products) => store.dispatch(setAllProducts(products));
